import { gql } from '@apollo/client';

import { useQuery } from 'api';
import permissions from 'api/Apollo/permissions';

const query = gql`
  query Integrations {
    integrations {
      id
      name
      starterkitId
    }
  }
`;

export default ({ variables, ...options } = {}) => {
  const { data, loading, error, isAllowed } = useQuery(query, {
    context: { permission: permissions.readIntegration },
    variables,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    integrations: data?.integrations || [],
    loading,
    isAllowed,
    error,
  };
};
